import React, {lazy, Suspense} from 'react'

const MyActivitiesLazy = lazy(() =>
  import('./MyActivities')
)

const MyActivities = props => (
  <Suspense fallback={null}>
    <MyActivitiesLazy {...props} />
  </Suspense>
)

export default MyActivities
